export default {
  "menu.RectificationAndReportingPage": "安全自检",
}